import { FC } from "react";
import { NavLink } from "react-router-dom";

const BackChevronIcon: FC = () => (
  <svg
    className="home-series__back-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <line x1="19" y1="12" x2="5" y2="12" />
    <polyline points="12 19 5 12 12 5" />
  </svg>
);

/** 页面级返回链接：与旧 Header leading 内一致的返回样式，现归属页面主内容顶部 */
export const PageBackLink: FC<{
  to: string;
  "aria-label": string;
}> = ({ to, "aria-label": ariaLabel }) => (
  <NavLink to={to} className="home-series__back" aria-label={ariaLabel}>
    <BackChevronIcon />
  </NavLink>
);

/** 页面级返回按钮：用于需先执行逻辑再 navigate 的场景 */
export const PageBackButton: FC<{
  onClick: () => void;
  "aria-label": string;
}> = ({ onClick, "aria-label": ariaLabel }) => (
  <button type="button" className="home-series__back" onClick={onClick} aria-label={ariaLabel}>
    <BackChevronIcon />
  </button>
);
